.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 140px;
}

.container .icon {
  background: #ff7f7f;
  padding: 14px;
  font-size: 40px;
  border-radius: 5px;
}

h2 {
  font-weight: 600;
}

.external-link {
  vertical-align: middle;
}
